import React from 'react';
import Drawer from '../../ui/drawer';
import EditQuantity from './components/edit-quantity';
import css from './regular-quantity-editor-popup.scss';
const RegularQuantityEditorPopup = ({
  open,
  onClose
}) => {
  return /*#__PURE__*/React.createElement(Drawer, {
    dataDrawer: "RegularProductEditQuantity",
    headerTitle: "Edit quantity",
    open: open,
    onClose: onClose,
    paperClassName: css.paper,
    headerClassName: css.headerClassName,
    bodyClassName: css.bodyClassName,
    closeClassName: css.closeClassName
  }, /*#__PURE__*/React.createElement(EditQuantity, {
    inputClassName: css.inputClassName,
    sizeItemLabelClassName: css.sizeItemLabelClassName
  }));
};
export default RegularQuantityEditorPopup;